import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, onMounted, onUnmounted, ref } from 'vue'
import router from '@/mobile/src/router'
import store from '@/mobile/src/store'
import ReelSlide from './ReelSlide.vue'
import Loading from '@/components/Loading.vue'
import { pendoTrackEvent } from '@/utils/pendo'

const SLIDE_TIME_DURATION = 5000


export default /*#__PURE__*/_defineComponent({
  __name: 'Reels',
  setup(__props) {

const closeReels = () => {
    pendoTrackEvent('reel_time_closed')
    router.push('/')
}

const slidesData = computed(() => store.getters['reels/allReels'])
const isReelsLoading = computed(() => store.getters['reels/loadingStatus'])
const currentSlideIndex = ref(0)

let slideTransitionInterval: NodeJS.Timeout

onMounted(async () => {
    await store.dispatch('reels/loadReelsList')
    if (
        !isReelsLoading.value &&
        (!slidesData.value?.length || slidesData.value?.length === 0)
    ) {
        return await router.push('/')
    }

    pendoTrackEvent('reel_time_viewed')
    slideTransitionInterval = setInterval(() => {
        const maxIndex = slidesData.value.length
        currentSlideIndex.value = (currentSlideIndex.value + 1) % maxIndex
    }, SLIDE_TIME_DURATION)
})

onUnmounted(() => {
    clearInterval(slideTransitionInterval)
})

return (_ctx: any,_cache: any) => {
  return (isReelsLoading.value)
    ? (_openBlock(), _createBlock(Loading, {
        key: 0,
        loading: isReelsLoading.value
      }, null, 8, ["loading"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(ReelSlide, {
          key: currentSlideIndex.value,
          title: slidesData.value[currentSlideIndex.value]?.title ?? '',
          message: slidesData.value[currentSlideIndex.value]?.message ?? '',
          "can-share": slidesData.value[currentSlideIndex.value]?.canShare ?? '',
          score: slidesData.value[currentSlideIndex.value]?.score ?? '',
          "can-add-report-card": 
                slidesData.value[currentSlideIndex.value]?.canAddReportCard ?? ''
            ,
          "slide-time-duration": SLIDE_TIME_DURATION,
          close: closeReels
        }, null, 8, ["title", "message", "can-share", "score", "can-add-report-card"]))
      ]))
}
}

})